import AudiobarContainer from 'components/Audiobar/AudiobarContainer'
import AudiobarPresentation from 'components/Audiobar/AudiobarPresentation'
import AudiobarData from 'components/Audiobar/AudiobarData'

export default {
  Container: AudiobarContainer,
  Presentation: AudiobarPresentation,
  Data: AudiobarData,
}
